// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.settings_dashboard__FHk5D {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.settings_dashboardContain__U2OSm {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.settings_bodythemedark__CUjRX .settings_dashboardContain__U2OSm,
.settings_bodythemedark__CUjRX .settings_dashboard__FHk5D,
.settings_bodythemedark__CUjRX .settings_cont2__VlNwH {
  background-Color: #0f1824;
}

.settings_top_header__ff-Zj .settings_top_header_inner__CdYKG {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.settings_cont2__VlNwH {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.settings_subLink__DFs3N svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.settings_footer__P4xQU {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.settings_bodythemelight__daVLj {
  background-color: #fff;
  padding-top: 90px;
}

.settings_bodythemedark__CUjRX {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.settings_headerthemelight__-DecU {
  background-color: #fff;
}

.settings_headerthemedark__VXMQL {
  background-color: #132337;
}

.settings_top_header__ff-Zj {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.settings_menuthemelight__xa936 {
  background-color: #fff;
}

.settings_menuthemedark__0RlW9 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.settings_menulinklight__2ukHf span {
  color: #666666 !important;
}

.settings_menulinklight__2ukHf a {
  color: #CBCBCB !important;
}

.settings_menulinklight__2ukHf:hover span, .settings_menulinklight__2ukHf:hover a {
  color: #fff !important;
}

.settings_menulinkdarkSelected__qg5eL {
  background-color: #1c2e45;
  color: #fff;
}

.settings_menuthemelight__xa936 .settings_menulinklightSelected__-Sh8x {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.settings_menulinkdark__ZEp0Q {
  color: #60677e !important;
}

.settings_menulinklight__2ukHf:hover {
  color: #fff !important;
  background-color: #205440;
}

.settings_menulinkdark__ZEp0Q:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.settings_headinglight__doSQ0 {
  color: #60677e;
}

.settings_headingdark__n\\+TEX {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.settings_searchboxlight__Exe8H {
  background-color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy {
  background-color: #132337;
  color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.settings_tableheadlight__I2wDM {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.settings_tableheadlight__I2wDM th {
  color: #fff;
}

thead .settings_tableheadlight__I2wDM th:first-child,
thead .settings_tableheaddark__BAzcZ th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .settings_tableheadlight__I2wDM th:last-child,
thead .settings_tableheaddark__BAzcZ th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.settings_table__wcs2I.settings_table-borderless__XlVcO {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.settings_tableheaddark__BAzcZ {
  background-color: #1e1e2d;
  color: #fff;
}

.settings_table-borderless__XlVcO tr:nth-child(even) {
  background-color: #F9FAFB;
}

.settings_table-borderless__XlVcO .settings_left-section__Mo-jA {
  padding-top: 10px;
}

.settings_tablebodylight__F8haX td,
.settings_tablebodydark__qeszF td {
  padding: 1rem 1rem !important;
}

.settings_tablebodylight__F8haX {
  background-color: #fff;
}
.settings_tablebodylight__F8haX:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.settings_tablebodydark__qeszF {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.settings_tablebodydark__qeszF:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.settings_paginationlight__BGULt {
  color: #60677e !important;
  font-size: 13px !important;
}

.settings_paginationdark__Hz6pf {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.settings_formthemelight__HnEnB {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.settings_formthemedark__ffb0i {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.settings_formthemedark__ffb0i ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.settings_viewformlight__AIIgi {
  background-color: #f3f6f9;
}

.settings_permissionboxlight__UvL2i {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.settings_permissionboxdark__qBhr4 {
  background-color: #151521;
  border: solid 1px #242434;
}

.settings_errormsgclr__QmeiF {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.settings_graphclrlight__rlfpD {
  background-color: #fff;
}

.settings_graphclrdark__tho2P {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#settings_card1bglight__mR3L5 {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#settings_card1bglight__mR3L5:hover {
  background: #f7fffc;
}

#settings_card1bgdark__HX9ph {
  background: #392f28;
}

#settings_card1bgdark__HX9ph:hover {
  background: #f7fffc;
}

#settings_card2bglight__\\+y-JH {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#settings_card2bglight__\\+y-JH:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#settings_card2bgdark__Kfhe7 {
  background: #1c3238;
}

#settings_card3bglight__XbcQO {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#settings_card3bglight__XbcQO:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#settings_card3bgdark__ILj6B {
  background: #3a2434;
}

#settings_card4bglight__fGD5L {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#settings_card4bglight__fGD5L:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#settings_card4bgdark__0tK9O {
  background: #2f264f;
}

#settings_card1bgdark__HX9ph a, #settings_card1bgdark__HX9ph p,
#settings_card2bgdark__Kfhe7 a, #settings_card2bgdark__Kfhe7 p,
#settings_card3bgdark__ILj6B a, #settings_card3bgdark__ILj6B p,
#settings_card4bgdark__0tK9O a, #settings_card4bgdark__0tK9O p {
  color: #fff;
}

/* 
Action button theme
*/
.settings_actionbtnlight__4Sk0H {
  color: rgba(70, 71, 91, 0.8705882353);
}

.settings_actionbtndark__La-Jh {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.settings_profiledropdownlight__NbgyO {
  background-color: #fff;
}

.settings_profiledropdowndark__D0QpQ {
  background-color: #151521;
}

.settings_settingsection__xu5at #settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_savebtn__yNpbe {
  background-color: #0a2574;
  color: #fff;
}

#settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_savebtn__yNpbe {
  background-color: #0a2574;
  color: #fff;
}

.settings_profile_conatiner__rzq8z {
  border-radius: 5px !important;
}

.settings_bodythemedark__CUjRX .settings_ag-theme-alpine__wCbtM .settings_ag-row__xu1As {
  background: #000 !important;
}

.settings_bodythemedark__CUjRX .settings_formbtn__mm3Wt {
  background-color: #0a2574;
}

.settings_bodythemedark__CUjRX .settings_resetbtn__FRARY {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.settings_bodythemedark__CUjRX .settings_resetbtn__FRARY:hover {
  background-color: #0a2574;
}

.settings_headingdark__n\\+TEX span {
  background-color: #132337;
}

.settings_resetbtn__FRARY {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.settings_resetbtn__FRARY:hover,
.settings_resetbtn__FRARY:active,
.settings_resetbtn__FRARY:focus {
  background-color: #205440;
  color: #fff;
}

.settings_addBtn__eaiUM {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.settings_addBtn__eaiUM svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.settings_addBtn__eaiUM:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.settings_cust_addBtn__OhiGl.settings_addBtn__eaiUM svg {
  top: 2px;
}

.settings_deleteBtn__bL4Ju {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.settings_deleteBtn__bL4Ju {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.settings_deleteBtn__bL4Ju:active, .settings_deleteBtn__bL4Ju:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.settings_deleteBtn__bL4Ju svg {
  position: relative;
  top: -2px;
}

.settings_deleteBtn__bL4Ju:hover,
.settings_deleteBtn__bL4Ju:active,
.settings_deleteBtn__bL4Ju:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.settings_confirmBtn__Wnp0z {
  background-color: #205440;
}

.settings_confirmBtn__Wnp0z:hover,
.settings_confirmBtn__Wnp0z:active,
.settings_confirmBtn__Wnp0z:focus {
  background-color: #205440;
}

.settings_confirmBtn__Wnp0z svg {
  top: 0;
}

.settings_back_dlt__9fzw3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings_delPopContainer__FCjdY .settings_modal-body__MJgKL {
  padding: 25px;
  text-align: center;
}

.settings_delPopContainer__FCjdY .settings_delet_icon__uP6T3 {
  margin-bottom: 11px;
}

.settings_delPopContainer__FCjdY p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.settings_arrowback__qnVSX svg {
  fill: #000;
}

.settings_bodythemedark__CUjRX .settings_arrowback__qnVSX {
  background-color: #0a2574;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_arrowback__qnVSX svg {
  fill: #fff;
}

.settings_bodythemedark__CUjRX .settings_drpdwn_btn__PsPxB {
  background-color: #132337;
}

.settings_bodythemedark__CUjRX .settings_empname__6QldI {
  color: #60677e !important;
}

.settings_bodythemedark__CUjRX .settings_navitemli__4IC51 a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingsgeneral__0GBoO,
.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingslinks__vcT1Z:hover {
  background-color: #0a2574;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingslinks__vcT1Z {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .settings_tableheadlight__I2wDM th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .settings_dashboard__FHk5D {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #settings_dashboardcont2__qbjfj {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .settings_sectionright__lAAyc {
    float: unset !important;
  }
  .settings_dashboard__FHk5D {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .settings_cont2__VlNwH {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .settings_bodythemelight__daVLj, .settings_bodythemedark__CUjRX {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .settings_exer_modal_contain__Yk2sS .settings_modal-dialog__6cI4N {
    max-width: 1055px;
  }
  .settings_delPopContainer__FCjdY .settings_modal-dialog__6cI4N {
    max-width: 350px;
  }
}
.settings_settingsection__xu5at {
  margin-bottom: 50px;
  padding-bottom: 30px;
}
.settings_settingsection__xu5at #settings_settingsheading__E8AHc {
  font-size: 18px;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
}
.settings_settingsection__xu5at .settings_settingsgeneral__0GBoO {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
  color: #fff;
  background-color: #205440;
}
.settings_settingsection__xu5at .settings_formthemedark__ffb0i .settings_settingsgeneral__0GBoO {
  background-color: #0a2574;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z:hover {
  color: #fff;
  background-color: #205440;
}
.settings_settingsection__xu5at .settings_formthemedark__ffb0i .settings_settingslinks__vcT1Z:hover {
  color: #fff;
  background-color: #0a2574;
}
.settings_settingsection__xu5at .settings_settingsgeneral__0GBoO:hover {
  color: #fff;
  background-color: #205440;
}
.settings_settingsection__xu5at #settings_layoutnav__xQYLn {
  border-radius: 5px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj {
  margin-top: 30px;
  padding: 30px;
  border-radius: 5px;
  display: flex;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj form {
  width: 100%;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_wrapper__FyIeM {
  width: 100%;
  padding-left: 30px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_savebtn__yNpbe {
  border: none;
  border-radius: 5px;
  background-color: #205440;
  padding: 10px;
  color: #fff;
  font-size: 14px;
  margin-top: 10px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_inputbox__7agbd {
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_inputbox1__5RkFm {
  padding: 5px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_formlabel__Bs5lx {
  font-size: 14px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_formlabel1__b1qS9 {
  color: #f8f9fa;
  font-size: 12px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_logo__2Nn6k {
  border: 1px solid rgba(81, 83, 101, 0.28);
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  width: 510px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj .settings_editbtnsection__8ps9W {
  position: relative;
  margin-top: -37px;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj #settings_penicon__ZuNGm {
  margin-left: 175px;
  font-size: 14px;
  background-color: #60677e;
  padding: 5px;
  border-radius: 50%;
  color: #e9ecef;
  cursor: pointer;
}
.settings_settingsection__xu5at #settings_addform__Dk7Mj #settings_penicon__ZuNGm:hover {
  background-color: #205440;
}

.settings_upload__Nn90h {
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  padding: 6px 0px 0px 3px;
  width: 90px;
  margin-left: 205px;
  margin-top: -45px;
  border-radius: 5px;
}

.settings_uploadicon__tIHlL {
  color: #1d1d1d;
  font-size: 18px;
  cursor: pointer;
}
.settings_uploadicon__tIHlL:hover {
  color: #205440;
}

.settings_crossicon__Z8MI\\+ {
  color: #1d1d1d;
  font-size: 16px;
  margin-left: 40px;
  cursor: pointer;
}
.settings_crossicon__Z8MI\\+:hover {
  color: #205440;
}

@media only screen and (max-width: 1200px) {
  .settings_logo__2Nn6k {
    width: 300px !important;
  }
}
@media only screen and (max-width: 878px) {
  #settings_layoutnav__xQYLn {
    display: flex !important;
  }
}
@media only screen and (max-width: 768px) {
  #settings_addform__Dk7Mj {
    display: block !important;
  }
  .settings_wrapper__FyIeM {
    padding-left: 0px !important;
  }
  .settings_logo__2Nn6k {
    width: 100% !important;
  }
  .settings_settingsection__xu5at #settings_layoutnav__xQYLn li {
    margin-bottom: 10px;
  }
}
@media only screen and (max-width: 548px) {
  .settings_settingslinks__vcT1Z {
    font-size: 14px !important;
  }
  .settings_settingsgeneral__0GBoO {
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 400px) {
  .settings_settingslinks__vcT1Z {
    margin-right: 0px !important;
    font-size: 13px !important;
  }
  .settings_settingsgeneral__0GBoO {
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 600px) {
  #settings_dashboardcont2__qbjfj {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/settings/settings.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAlpBA;EACI,mBAAA;EACA,oBAAA;AAopBJ;AAlpBI;EACI,eAAA;AAopBR;AAlpBI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AAopBR;AAjpBI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WD4BM;EC3BN,yBDwCW;AC2mBnB;AAjpBI;EACI,yBDgBe;ACmoBvB;AAhpBI;EACI,WDoBM;ECnBN,yBDgCW;ACknBnB;AA/oBI;EACI,WDeM;ECdN,yBDMe;AC2oBvB;AA9oBI;EACI,WDUM;ECTN,yBDsBW;AC0nBnB;AA3nBK;EACG,kBAAA;AA6nBR;AA1nBM;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AA4nBV;AA3nBU;EACE,WAAA;AA6nBZ;AA3nBU;EACE,WAAA;EACA,kBAAA;AA6nBZ;AA1nBgB;EACI,YAAA;EACA,kBAAA;EACA,yBDnBD;ECoBC,aAAA;EACA,WDlCN;ECmCM,eAAA;EACA,gBAAA;AA4nBpB;AA1nBgB;EACI,kBAAA;EACA,WAAA;EACA,eAAA;AA4nBpB;AA1nBgB;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDlDH;ECmDG,cD9CH;AC0qBjB;AAznBgB;EAEI,eAAA;AA0nBpB;AAxnBgB;EACI,cAAA;EAEA,eAAA;AAynBpB;AAtnBgB;EACI,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAwnBpB;AAtnBgB;EACI,kBAAA;EACA,iBAAA;AAwnBpB;AArnBgB;EACI,kBAAA;EACA,eAAA;EACA,yBD1EH;EC2EG,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAunBpB;AArnBqB;EACG,yBDvEL;AC8rBnB;;AA/mBA;EACI,yBAAA;EACA,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAknBJ;;AAhnBA;EACI,cDrGU;ECsGV,eAAA;EACA,eAAA;AAmnBJ;AAjnBI;EACI,cD9FW;ACitBnB;;AAhnBA;EACI,cD9GU;EC+GV,eAAA;EACA,iBAAA;EACA,eAAA;AAmnBJ;AAjnBI;EACG,cDxGY;AC2tBnB;;AA5mBA;EACI;IACI,uBAAA;EA+mBN;AACF;AA7mBA;EACG;IACC,wBAAA;EA+mBF;AACF;AA5mBA;EACI;IACI,yBAAA;EA8mBN;EA5mBE;IACI,4BAAA;EA8mBN;EA5mBE;IACI,sBAAA;EA8mBN;EA5mBE;IACI,mBAAA;EA8mBN;AACF;AA5mBA;EAEI;IACC,0BAAA;EA6mBH;EA1mBE;IACI,0BAAA;EA4mBN;AACF;AAxmBC;EAEG;IACC,4BAAA;IACA,0BAAA;EAymBH;EAtmBE;IACI,0BAAA;EAwmBN;AACF;AArmBA;EACI;IACI,wBDjJI;ICkJJ,UDjJG;ICkJH,kBAAA;IACA,aDzJW;ECgwBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.settingsection{\n    margin-bottom: 50px;\n    padding-bottom:30px;\n\n    #settingsheading{\n        font-size: 18px;\n    }\n    .settingslinks{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n    }\n\n    .settingsgeneral{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n    .formthemedark .settingsgeneral{\n        background-color: $darkTheme_updateBtn;\n    }\n\n    .settingslinks:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n\n    .formthemedark .settingslinks:hover{\n        color: $white-color;\n        background-color: $darkTheme_updateBtn;\n    }\n    \n    .settingsgeneral:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n      }\n\n    // .settingslinks:after {    \n    //     background: none repeat scroll 0 0 transparent;\n    //     bottom: 0;\n    //     content: \"\";\n    //     display: block;\n    //     // height: 1.6px;\n    //     left: 50%;\n    //     position: absolute;\n    //     background:  $primary-btncolor;\n    //     transition: width 0.3s ease 0s, left 0.3s ease 0s;\n    //     width: 0;\n    //     border-bottom: 2px solid  $primary-btncolor;\n    //   }\n    //   .settingslinks:hover:after { \n    //     width: 100%; \n    //     left: 0; \n    //   }\n     \n     #layoutnav{\n        border-radius: 5px;\n     }\n\n      #addform{\n          margin-top: 30px;\n          padding: 30px;\n          border-radius: 5px;\n          display: flex;\n          form {\n            width: 100%;\n          }\n          .wrapper {\n            width: 100%;\n            padding-left: 30px;\n          }\n\n                .savebtn{\n                    border: none;\n                    border-radius: 5px;\n                    background-color: $primary-btncolor;\n                    padding: 10px;\n                    color: $white-color;\n                    font-size: 14px;\n                    margin-top: 10px;\n                }\n                .inputbox{\n                    border-radius: 5px;\n                    width: 100%;\n                    font-size: 14px;\n                }\n                .inputbox1{\n                    padding: 5px;\n                    border: none;\n                    border-radius: 5px;\n                    width: 100%;\n                    background-color: $darkthemecolor;\n                    color: $lightthemetext;\n                     \n                }\n                .formlabel{\n                     \n                    font-size: 14px;\n                }\n                .formlabel1{\n                    color: #f8f9fa;\n                     \n                    font-size: 12px;\n                }\n\n                .logo{\n                    border: 1px solid rgb(81 83 101 / 28%);\n                    padding: 10px;\n                    margin-bottom: 20px;\n                    border-radius: 5px;\n                    width: 510px;\n                }\n                .editbtnsection{\n                    position: relative;\n                    margin-top: -37px;\n                }\n                \n                #penicon{\n                    margin-left:175px;\n                    font-size: 14px;\n                    background-color: $lightthemetext;\n                    padding: 5px;\n                    border-radius: 50%;\n                    color: #e9ecef;\n                    cursor: pointer;\n                \n                     &:hover{\n                        background-color: $primary-btncolor;\n                     }\n                }\n                \n      }\n}\n\n \n.upload{\n    border: 1px solid #dee2e6;\n    background-color: #f8f9fa;\n    padding: 6px 0px 0px 3px;\n    width: 90px;\n    margin-left: 205px;\n    margin-top: -45px;\n    border-radius:5px;\n}\n.uploadicon{\n    color: $black-color;\n    font-size: 18px;\n    cursor: pointer;\n\n    &:hover{\n        color: $primary-btncolor;\n     }\n}\n.crossicon{\n    color: $black-color;\n    font-size: 16px;\n    margin-left: 40px;\n    cursor: pointer;\n\n    &:hover{\n       color: $primary-btncolor;\n     }\n\n}\n\n\n\n@media only screen and (max-width: 1200px) { \n    .logo{\n        width: 300px !important;\n    }\n}\n@media only screen and (max-width: 878px) {\n   #layoutnav{\n    display: flex !important;\n   }\n}\n\n@media only screen and (max-width: 768px) { \n    #addform{\n        display: block !important;\n    }\n    .wrapper {\n        padding-left: 0px !important;\n    }\n    .logo{\n        width: 100% !important;\n    }\n    .settingsection #layoutnav li {\n        margin-bottom: 10px;\n    }\n}\n@media only screen and (max-width: 548px) {\n\n    .settingslinks{\n     font-size: 14px !important;\n    }\n\n    .settingsgeneral{\n        font-size: 14px !important;\n    }\n }\n\n\n @media only screen and (max-width: 400px) {\n\n    .settingslinks{\n     margin-right: 0px !important;\n     font-size: 13px !important;\n    }\n\n    .settingsgeneral{\n        font-size: 13px !important;\n    }\n }\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `settings_dashboard__FHk5D`,
	"dashboardContain": `settings_dashboardContain__U2OSm`,
	"bodythemedark": `settings_bodythemedark__CUjRX`,
	"cont2": `settings_cont2__VlNwH`,
	"top_header": `settings_top_header__ff-Zj`,
	"top_header_inner": `settings_top_header_inner__CdYKG`,
	"subLink": `settings_subLink__DFs3N`,
	"footer": `settings_footer__P4xQU`,
	"bodythemelight": `settings_bodythemelight__daVLj`,
	"headerthemelight": `settings_headerthemelight__-DecU`,
	"headerthemedark": `settings_headerthemedark__VXMQL`,
	"menuthemelight": `settings_menuthemelight__xa936`,
	"menuthemedark": `settings_menuthemedark__0RlW9`,
	"menulinklight": `settings_menulinklight__2ukHf`,
	"menulinkdarkSelected": `settings_menulinkdarkSelected__qg5eL`,
	"menulinklightSelected": `settings_menulinklightSelected__-Sh8x`,
	"menulinkdark": `settings_menulinkdark__ZEp0Q`,
	"headinglight": `settings_headinglight__doSQ0`,
	"headingdark": `settings_headingdark__n+TEX`,
	"searchboxlight": `settings_searchboxlight__Exe8H`,
	"searchboxdark": `settings_searchboxdark__0LYGy`,
	"tableheadlight": `settings_tableheadlight__I2wDM`,
	"tableheaddark": `settings_tableheaddark__BAzcZ`,
	"table": `settings_table__wcs2I`,
	"table-borderless": `settings_table-borderless__XlVcO`,
	"left-section": `settings_left-section__Mo-jA`,
	"tablebodylight": `settings_tablebodylight__F8haX`,
	"tablebodydark": `settings_tablebodydark__qeszF`,
	"paginationlight": `settings_paginationlight__BGULt`,
	"paginationdark": `settings_paginationdark__Hz6pf`,
	"formthemelight": `settings_formthemelight__HnEnB`,
	"formthemedark": `settings_formthemedark__ffb0i`,
	"viewformlight": `settings_viewformlight__AIIgi`,
	"permissionboxlight": `settings_permissionboxlight__UvL2i`,
	"permissionboxdark": `settings_permissionboxdark__qBhr4`,
	"errormsgclr": `settings_errormsgclr__QmeiF`,
	"graphclrlight": `settings_graphclrlight__rlfpD`,
	"graphclrdark": `settings_graphclrdark__tho2P`,
	"card1bglight": `settings_card1bglight__mR3L5`,
	"card1bgdark": `settings_card1bgdark__HX9ph`,
	"card2bglight": `settings_card2bglight__+y-JH`,
	"card2bgdark": `settings_card2bgdark__Kfhe7`,
	"card3bglight": `settings_card3bglight__XbcQO`,
	"card3bgdark": `settings_card3bgdark__ILj6B`,
	"card4bglight": `settings_card4bglight__fGD5L`,
	"card4bgdark": `settings_card4bgdark__0tK9O`,
	"actionbtnlight": `settings_actionbtnlight__4Sk0H`,
	"actionbtndark": `settings_actionbtndark__La-Jh`,
	"profiledropdownlight": `settings_profiledropdownlight__NbgyO`,
	"profiledropdowndark": `settings_profiledropdowndark__D0QpQ`,
	"settingsection": `settings_settingsection__xu5at`,
	"addform": `settings_addform__Dk7Mj`,
	"savebtn": `settings_savebtn__yNpbe`,
	"profile_conatiner": `settings_profile_conatiner__rzq8z`,
	"ag-theme-alpine": `settings_ag-theme-alpine__wCbtM`,
	"ag-row": `settings_ag-row__xu1As`,
	"formbtn": `settings_formbtn__mm3Wt`,
	"resetbtn": `settings_resetbtn__FRARY`,
	"addBtn": `settings_addBtn__eaiUM`,
	"cust_addBtn": `settings_cust_addBtn__OhiGl`,
	"deleteBtn": `settings_deleteBtn__bL4Ju`,
	"confirmBtn": `settings_confirmBtn__Wnp0z`,
	"back_dlt": `settings_back_dlt__9fzw3`,
	"delPopContainer": `settings_delPopContainer__FCjdY`,
	"modal-body": `settings_modal-body__MJgKL`,
	"delet_icon": `settings_delet_icon__uP6T3`,
	"arrowback": `settings_arrowback__qnVSX`,
	"drpdwn_btn": `settings_drpdwn_btn__PsPxB`,
	"empname": `settings_empname__6QldI`,
	"navitemli": `settings_navitemli__4IC51`,
	"tabnavli": `settings_tabnavli__-QWK2`,
	"settingsgeneral": `settings_settingsgeneral__0GBoO`,
	"settingslinks": `settings_settingslinks__vcT1Z`,
	"dashboardcont2": `settings_dashboardcont2__qbjfj`,
	"sectionright": `settings_sectionright__lAAyc`,
	"exer_modal_contain": `settings_exer_modal_contain__Yk2sS`,
	"modal-dialog": `settings_modal-dialog__6cI4N`,
	"settingsheading": `settings_settingsheading__E8AHc`,
	"layoutnav": `settings_layoutnav__xQYLn`,
	"wrapper": `settings_wrapper__FyIeM`,
	"inputbox": `settings_inputbox__7agbd`,
	"inputbox1": `settings_inputbox1__5RkFm`,
	"formlabel": `settings_formlabel__Bs5lx`,
	"formlabel1": `settings_formlabel1__b1qS9`,
	"logo": `settings_logo__2Nn6k`,
	"editbtnsection": `settings_editbtnsection__8ps9W`,
	"penicon": `settings_penicon__ZuNGm`,
	"upload": `settings_upload__Nn90h`,
	"uploadicon": `settings_uploadicon__tIHlL`,
	"crossicon": `settings_crossicon__Z8MI+`
};
export default ___CSS_LOADER_EXPORT___;
